<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-matiere-card">
    <div class="card-header">
      <h3 class="text-black fw-semibold">Ajouter une publication</h3>
    </div>

    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form @submit="addPublication" :validation-schema="publicationSchema">
        <div class="row">
          <!-- Catégorie -->
          <div class="col-md-6">
            <div class="form-group mb-20">
              <label class="d-block text-black fw-semibold mb-10">
                Catégorie de publication <span class="text-danger">*</span>
              </label>
              <Field name="categorie" v-slot="{ field }">
                <Multiselect
                  :options="categorieOptions"
                  :searchable="false"
                  v-model="field.value"
                  v-bind="field"
                  placeholder="Sélectionner la catégorie"
                />
              </Field>
              <ErrorMessage name="categorie" class="text-danger" />
            </div>
          </div>
          <!-- Titre -->
          <div class="col-md-6">
            <div class="form-group mb-20">
              <label class="d-block text-black fw-semibold mb-10">
                Titre <span class="text-danger">*</span>
              </label>
              <Field
                name="titre"
                type="text"
                class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer le titre"
              />
              <ErrorMessage name="titre" class="text-danger" />
            </div>
          </div>

          <!-- Auteur -->
          <div class="col-md-6">
            <div class="form-group mb-20">
              <label class="d-block text-black fw-semibold mb-10">
                Auteur <span class="text-danger">*</span>
              </label>
              <Field
                name="auteur"
                type="text"
                class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer l’auteur"
              />
              <ErrorMessage name="auteur" class="text-danger" />
            </div>
          </div>

          <!-- Année -->
          <div class="col-md-6">
            <div class="form-group mb-20">
              <label class="d-block text-black fw-semibold mb-10">
                Année <span class="text-danger"></span>
              </label>
              <Field
                name="annee"
                type="number"
                class="form-control shadow-none fs-md-15 text-black"
                placeholder="Ex : 2024"
              />
              <ErrorMessage name="annee" class="text-danger" />
            </div>
          </div>

          <!-- Éditeur -->
          <div class="col-md-6">
            <div class="form-group mb-20">
              <label class="d-block text-black fw-semibold mb-10">
                Maison d'Edition <span class="text-danger"></span>
              </label>
              <Field
                name="editeur"
                type="text"
                class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer l’éditeur"
              />
              <ErrorMessage name="maisonedition" class="text-danger" />
            </div>
          </div>
          <!-- Image -->
          <div class="col-md-6" >
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
              Image
              </label>
              <input
                type="file"
                class="form-control shadow-none fs-md-15 text-black"
                accept="image/jpeg, image/png"
                @change="onImageChange"
              />

            </div>
            <ErrorMessage name="urlImage" class="text-danger"/>
          </div>


          <!-- Contenu -->
          <div class="col-md-12">
            <div class="form-group mb-25">
              <label class="d-block text-black fw-semibold mb-10">
                Contenu <span class="text-danger"></span>
              </label>
              <QuillEditor
                ref="contenuEditor"
                v-model:content="contenu"
                content-type="html"
                theme="snow"
                toolbar ="full"
              />

              <ErrorMessage name="contenu" class="text-danger" />
            </div>
          </div>

          <!-- Boutons -->
          <div class="col-md-12">
            <div class="d-flex align-items-center">
              <button class="btn btn-success me-3" type="submit">
                <i class="fa fa-plus me-2"></i>
                Ajouter la publication
              </button>

              <router-link to="/listPublication" class="btn btn-danger">
                <i class="fa fa-times me-1"></i>
                Annuler
              </router-link>
            </div>
          </div>

        </div>
      </Form>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, ref } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as Yup from "yup";
import Multiselect from "@vueform/multiselect";
import ApiService from "@/services/ApiService";
import { success, error } from "@/utils/utils";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "AddPublication",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,
  },
  setup() {
    const contenu = ref("");
    const contenuEditor = ref();
    const categorieOptions = ref([
      "Mémoire",
      "Textes",
      "Publication enseignant",
    ]);
    const router = useRouter();
    const publicationSchema = Yup.object({
      urlImage: Yup.string().notRequired(),
      titre: Yup.string().required("Le titre est obligatoire"),
      auteur: Yup.string().required("L’auteur est obligatoire"),
      categorie: Yup.string().required("La catégorie est obligatoire"),
      contenu: Yup.string().notRequired(),
      annee: Yup.number().notRequired(),
      maisonedition: Yup.string().notRequired(),
    });
    const imageFile = ref<File | null>(null);

    const onImageChange = (event: Event) => {
      const target = event.target as HTMLInputElement;
      if (target.files && target.files.length > 0) {
        imageFile.value = target.files[0];
      }
    };
    const empty = ref("<p><br></p>")
    const showA = ref(false)
    const show = ref("0")
    const onSubmit = () => {
      if(contenuEditor.value.getHTML() !== empty.value) {
        showA.value = false;
        console.log('hijgrgrkjgmerjm')
      }
      else if(contenuEditor.value.getHTML() === empty.value) {
        showA.value = true;
        show.value = "1"
      }
    }
    const addPublication = async (values: any) => {
      try {
        const formData = new FormData();

        formData.append("titre", values.titre);
        formData.append("auteur", values.auteur);
        formData.append("categoriepublication", values.categorie);
        formData.append("contenu", contenuEditor.value.getHTML());
        formData.append("annepublication", values.annee);
        formData.append("editeur", values.editeur);

        if (imageFile.value) {
          formData.append("urlImage", imageFile.value);
        }

        await ApiService.post("/publications", formData, {
          headers:{ 'Content-Type': 'multipart/form-data','Accept': '*/*' } 
        });

        success("Publication ajoutée avec succès");
        router.push("/listPublication")
      } catch (e) {
        error("Erreur lors de l’enregistrement");
      }
    };


    return {
      contenu,
      contenuEditor,
      publicationSchema,
      categorieOptions,
      addPublication,
      onImageChange,
      onSubmit
    };
  },
});
</script>
<style scoped>
.add-publication-card textarea {
  resize: vertical;
}
</style>
